import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Popover, PopoverBody, Button } from "reactstrap";
import LoginForm from "../Common/Login/LoginForm";
import LoginMFA from "../Common/Login/LoginMFA";
import Text from "../components/Text";
import Messages from "../Shared/Messages";
import history from "../history";
import I18nProvider from "../services/I18nProvider";
import {
  onLogin as onLoginAction,
  onLoginWithMfa,
  onResetLoading,
} from "../State/actions/user";
import { isPatientOrMember, isMpsSupport } from "../security/roles";
import "./MelanomaLoginPopover.css";

const intl = I18nProvider.getIntlProvider();

const MelanomaLoginFormInner = (props) => {
  const { onClose, loginError, errorMessage, mfaRequired, loggedIn, role } = props;

  useEffect(() => {
    if (!loggedIn) return;
    if (isMpsSupport(role)) {
      history.push("/mps-patients");
    } else if (isPatientOrMember(role)) {
      history.push("/app");
    } else {
      history.push("/");
    }
  }, [loggedIn, role]);

  let displayError = errorMessage;
  if (errorMessage === "Invalid Credentials") {
    displayError = intl.formatMessage(Messages.error_logging_in);
  }

  return (
    <div className="mlp-login-form">
      {loginError && (
        <p className="text-danger small mb-2">{displayError}</p>
      )}
      {mfaRequired ? <LoginMFA {...props} /> : <LoginForm {...props} />}
      <div className="mt-2 text-center">
        <Button
          color="link"
          className="px-0"
          onClick={(e) => {
            e.preventDefault();
            if (onClose) onClose();
            history.push("/forgot-password");
          }}
        >
          <Text content={Messages.forgot_password} />
        </Button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  loading: state.user.loading,
  loginError: state.user.loginError,
  errorMessage: state.user.errorMessage,
  logoutMessage: state.user.logoutMessage,
  mfaRequired: state.user.mfaRequired,
  mfaToken: state.user.mfaToken,
  mfaMechanism: state.user.mfaMechanism,
  loggedIn: state.user.loggedIn,
  role: state.user.role,
});

const mapDispatchToProps = (dispatch) => ({
  onLogin: (username, password) =>
    dispatch(onLoginAction(username, password)),
  onLoginWithMfa: (code, token, mechanism) =>
    dispatch(onLoginWithMfa(code, token, mechanism)),
  onResetLoading: () => dispatch(onResetLoading()),
});

export const MelanomaLoginForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(MelanomaLoginFormInner);

const MelanomaLoginPopover = ({ isOpen, target, placement, onClose }) => {
  if (!isOpen || !target) return null;

  return (
    <Popover
      isOpen={isOpen}
      target={target}
      toggle={(e) => {
        if (
          e &&
          e.target &&
          e.target.closest &&
          e.target.closest(".region-selector-modal, .modal-backdrop")
        ) {
          return;
        }
        onClose();
      }}
      placement={placement || "bottom-end"}
      trigger="legacy"
      popperClassName="mlp-login-popover-root"
      hideArrow={false}
    >
      <PopoverBody className="mlp-login-popover-body">
        <div className="mlp-login-popover-title-row d-flex justify-content-between align-items-center">
          <h5 className="mb-0">
            <Text content={Messages.login_to_account} />
          </h5>
          <button
            type="button"
            className="close"
            onClick={onClose}
            aria-label={intl.formatMessage(Messages.close)}
          >
            <i className="fa fa-times" />
          </button>
        </div>
        <MelanomaLoginForm onClose={onClose} />
      </PopoverBody>
    </Popover>
  );
};

export default MelanomaLoginPopover;
